import React from 'react';
import BaseClass from '@/pages/BaseClass';

import {
	Form,
	Input,
	InputNumber,
	Button,
	Dropdown,
	Menu,
	Upload,
	Checkbox,
	Table,
	Image,
	Select,
	Modal,
	Divider,
	Steps,
	Radio,
	Result,
	Popconfirm,
	Space,
	Affix,
} from 'antd'
import $ from 'jquery';
/*
import OrderCategory from '@/components/OrderCategory';
import OrderAddress from '@/components/OrderAddress';
*/
import AddOrder from '@/components/AddOrder';
import {
	CommonValue,
	ngUrl,
	pcUrl,
	confirm,
	message,
	notify,
	parseTime,
	httpPost,
	getQuery,
} from '@/utils/Tools';

const {Column} = Table;
export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
			'mode':'index',
			'type':0,
			
			'userInfo':{},
			
			'checkAll':false,
			'usedStorage':'',
			'totalStorage':'',
			
			'folderImageList':{
				0:'folder_image_0.jpg',
				2:'folder_image_2.png',
			},
			'folderInfo':{
				'parentId':0,
				'folderId':0,
				'directoryName':'',
				'folderList':[{
					'folderId':0,
					'folderName':'/',
				}],
			},
			//购物车列表
			'cartList':[],
			'imageList':[],
			//生成缩略图中的图片ids
			'thumbingIds':[],
			'refreshLoop':null,
			
			//上传图片数量
			/*
			'uploadImageCount':0,
			'maxUploadImageCount':5,
			*/
			//上传队列
			'uploadFileList':[],
			
			'selectedImageList':[],
			'backPathList':[],
			
			'imageTypeList':[],
			'colorTypeList':[],
			
			'preview':{
				'visible':false,
				'src':'',
			},
			'clickEvent':{
				'lastTime':0,
				'timer':null,
			},
			
			'orderCurrent':0,
			'orderInfo':{
				'order_amount':0,
				/*
				"order_id": "21",
				"order_sn": "202205240346244729",
				"user_id": "1",
				"company_id": "1",
				"buyer_id": "1",
				"goods_amount": "1350.00",
				"shipping_fee": "0.00",
				"order_amount": "1350.00",
				"order_status": "0",
				"add_time": "1653335184",
				"finish_time": "0",
				"update_time": "0",
				"remark": ""
				*/
			},
			
			'addFolderName':'',
			'showAddFolderDialog':false,
			
			'showOrderDialog':false,
			//'showOrderDialog':true,
			
			'orderImageIndex':-1,
			'showCategoryDialog':false,
		};
	}
	
	componentDidMount()
	{
		let query = getQuery();
		let userInfo = CommonValue.get('user_info');
		let cartList = CommonValue.get('cart_list') || [];
		let type = 0;
		if(query.type != undefined)
		{
			type = query.type;
			this.state.type = type;
		}
		
		this.setState({
			'userInfo':userInfo,
			'cartList':cartList,
			'type':type,
		});
		
		this.getList();
		this.getImageTypeList();
		document.title = '广告喷印 - ' + CommonValue.get('site_name');
	}
	
	componentWillReceiveProps(nextProps)
	{
		if(nextProps.location.search != this.props.location.search)
		{
			let folderId = getQuery('folderId') || 0;
			let mode = getQuery('mode') || 'index';
			let folderInfo = this.state.folderInfo;
			let type = getQuery('type') || 0;
			
			if(folderId != folderInfo.folderId)
			{
				if(folderId == 0)
				{
					this.goFolder(0);
				}
			}
			if(mode != this.state.mode)
			{
				if(
					this.state.mode == 'addOrder' &&
					mode == 'index'
				)
					this.setState({'mode':'index'});
			}
			if(type != this.state.type)
			{
				this.setState({
					'type':type
				},()=>{
					this.goFolder(0);
				});
			}
			
			/*
			let mode = getQuery('mode') || 'index';
			*/
		}
	}
	
	componentWillUnmount()
	{
		if(this.loop)
			window.clearInterval(this.loop);
	}
	
	getList(checkThumb)
	{
		let url = pcUrl('image','index');
		let param = this.filterForm.getFieldsValue();
		param['order_type'] = this.state.type;
		if(param['image_name'])
		{
			param['is_directory'] = 0;
		}
		else
		{
			param['folder_id'] = this.state.folderInfo.folderId;
		}
		
		httpPost(url,param)
			.then(data=>{
				if(!checkThumb)
				{
					data['list'].forEach(row=>{
						row.isChecked = false;
					});
					//如果在子文件夹中
					if(param['folder_id'])
					{
						let index = data['list'].findIndex(row=>{
							if(row['image_id'] == param['folder_id'])
								return true;
						});
						let info = data['list'][index];
						let folderInfo = this.state.folderInfo;
						folderInfo['parentId'] = info['folder_id'];
						folderInfo['directoryName'] = info['image_path'];
						this.setState({
							'folderInfo':folderInfo,
						});
						
						data['list'].splice(index,1);
					}
					//根目录
					else
					{
						let folderInfo = this.state.folderInfo;
						folderInfo.folderId = 0;
						folderInfo.parentId = 0;
						folderInfo.directoryName = '/';
					}
					
					//获取上传中的记录
					let uploadList = this.state.imageList.filter(row=>row.uid && !['process','done'].includes(row.status));
					if(uploadList.length)
					{
						let index = data.list.findIndex(row=>!+row['is_directory']);
						Array.prototype.splice.apply(data.list,[index,0].concat(uploadList));
					}
					else
					{
						window.clearTimeout(this.state.refreshLoop);
						//如果还有正在上传中的图片，设置定时器
						if(data.list.some(row=>!+row['is_directory'] && row.status == 0))
						{
							this.state.thumbingIds = data.list
								.filter(row=>{
									return !+row['is_directory'] && row.status == 0;
								})
								.map(row=>row['image_id']);
							this.state.refreshLoop = window.setTimeout(()=>{
								this.getList(true);
							},5000);
						}
					}
					
					this.setState({
						'usedStorage':data['used_storage_exp'],
						'totalStorage':data['total_storage_exp'],
						'imageList':data['list'],
					});
				}
				//检查生成缩略图中的图片
				else
				{
					let thumbingIds = data.list
						.filter(row=>{
							return !+row['is_directory'] && row.status == 0;
						})
						.map(row=>row['image_id']);
					//获取已经生成缩略图的图片
					let doneIds = this.state.thumbingIds.filter(imageId=>!thumbingIds.includes(imageId));
					
					//更新图片的信息
					if(doneIds.length)
					{
						let imageList = this.state.imageList;
						doneIds.forEach(imageId=>{
							let imageInfo = data.list.find(row=>row['image_id'] == imageId);
							let index = imageList.findIndex(row=>row['image_id'] == imageId);
							//imageList[index]['status'] = imageInfo['status'];
							imageList[index] = imageInfo;
						});
						this.setState({
							imageList
						});
					}
					if(thumbingIds.length)
					{
						this.state.thumbingIds = thumbingIds;
						window.clearTimeout(this.state.refreshLoop);
						this.state.refreshLoop = window.setTimeout(()=>{
							this.getList(true);
						},5000);
					}
				}
			});
	}
	
	getImageTypeList()
	{
		let url = pcUrl('image','typeList');
		httpPost(url)
			.then(data=>{
				this.setState({
					//'typeList':data['type_list'][0].concat(data['type_list'][1]),
					'imageTypeList':data['type_list'][0].filter(str=>str!='png'),
					'colorTypeList':data['color_type_list'],
				});
			});
	}
	
	checkAll()
	{
		let checkAll = !this.state.checkAll;
		let imageList = this.state.imageList;
		imageList.filter(row=>!+row['is_directory']).forEach(row=>{
			row.isChecked = checkAll;
		});
		this.setState({
			'checkAll':checkAll,
			'imageList':imageList,
		});
	}
	
	addFolder()
	{
		this.setState({
			'addFolderName':'',
			'showAddFolderDialog':true,
		});
	}
	
	submitAddFolder()
	{
		let folderName = this.state.addFolderName;
		
		if(!folderName.length)
		{
			message('请输入文件夹名');
			return false;
		}
		
		let url = pcUrl('image','addFolder');
		let param = {
			'folder_name':folderName,
			'order_type':this.state.type,
		};
		if(this.state.folderInfo.folderId)
			param['folder_id'] = this.state.folderInfo.folderId;
			
		httpPost(url,param)
			.then(()=>{
				message('文件夹新建成功','success');
				this.setState({
					'showAddFolderDialog':false,
				});
				this.getList();
			});
	}
	
	//显示文件夹内容
	showFolder({folderId,folderName})
	{
		let folderInfo = this.state.folderInfo;
		folderInfo.folderId = +folderId;
		folderInfo.folderList.push({
			folderId,
			folderName,
		});
		this.setState({
			'folderInfo':folderInfo,
			'imageList':[],
		});
		
		this.getList();
		
		window.location.href=`#/imageList?type=${this.state.type}&folderId=${folderId}`;
	}
	
	//显示父文件夹
	/*
	showParentFolder()
	{
		let folderInfo = this.state.folderInfo;
		folderInfo.folderList.pop();
		folderInfo.folderId = +folderInfo.folderList[folderInfo.folderList.length - 1]['folderId'];
		this.setState({
			'folderInfo':folderInfo,
			'imageList':[],
		});
		this.getList();
	}
	*/
	
	//进入具体的文件夹层级
	goFolder(index)
	{
		let folderInfo = this.state.folderInfo;
		folderInfo.folderList = folderInfo.folderList.slice(0,index+1);
		let folderId = +folderInfo.folderList[folderInfo.folderList.length - 1]['folderId'];
		folderInfo.folderId = folderId;
		
		this.setState({
			'folderInfo':folderInfo,
			'imageList':[],
		});
		this.getList();
		
		let mode = this.state.mode;
		if(folderId)
			window.location.href=`#/imageList?type=${this.state.type}&folderId=${folderId}`;
		else
			window.location.href=`#/imageList?type=${this.state.type}`;
	}
	
	//删除文件夹
	deleteFolder(folderId,event)
	{
		event.stopPropagation();
		confirm('确认要删除该文件夹吗?')
			.then(()=>{
				let url = pcUrl('image','deleteFolder');
				let param = {
					'folder_id':folderId
				};
				httpPost(url,param)
					.then(()=>{
						message('文件夹删除成功','success');
						this.getList();
					});
			});
	}
	
	imageClick(index,e)
	{
		let info = this.state.imageList[index];
		if(info.status != 1) return;
		
		if(
			this.state.clickEvent.lastTime && 
			e.timeStamp - this.state.clickEvent.lastTime < 250
		)
		{
			//console.log('双击');
			window.clearTimeout(this.state.clickEvent.timer);
			//打开图片预览
			this.setState({
				'preview':{
					'visible':true,
					'src':info['image_path']['image_name'],
					//'src':info['image_path']['thumb_name'],
				},
			});
		}
		else
		{
			this.state.clickEvent.timer = window.setTimeout(()=>{
				//console.log('单击');
				info.isChecked = !info.isChecked;
				this.setState({
					//'imageList':{...this.state.imageList}
					'imageList':this.state.imageList
				});
			},250);
		}
			
		this.state.clickEvent.lastTime = e.timeStamp;
	}
	selectedImageClick(index)
	{
		let info = this.state.selectedImageList[index];
		//打开图片预览
		this.setState({
			'preview':{
				'visible':true,
				'src':info['image_path']['image_name'],
			},
		});
	}
	
	handleBeforeUpload(file)
	{
		let imageList = this.state.imageList;
		console.log(file);
		
		file.status = 'prepare';
		/*
		file.status = 'done';
		file['image_path'] = {
			'thumb_name':'http://b2b-print.test.com/uploads/20221202/3069ac964b07a2c36a3ee361671f00e3.thumb.jpg',
		};
		*/
		let index = imageList.findIndex(row=>!+row['is_directory']);
		
		this.state.uploadFileList.push(file);
		//imageList.unshift(file);
		imageList.splice(index,0,file);
		
		this.setState({
			'imageList':imageList,
		});
		this.handleUpload();
		
		/*
		this.state.uploadImageCount ++;
		
		if(this.state.uploadImageCount > this.state.maxUploadImageCount)
			return false;
		*/
	}
	
	handleCustomRequest()
	{
	}
	
	clickUpload()
	{
		let offset = $('.image-list-panel').offset();
		let top  =$('.image-list-panel').position().top;
		$('html ,body').animate({scrollTop: top},300);
	}
	
	handleUpload()
	{
		//let file = this.state.uploadFileList.pop();
		if(!this.state.uploadFileList.length) return;
		let file = this.state.uploadFileList[0];
		if(file.status != 'prepare') return;
		
		let imageList = this.state.imageList;
		file.progress = 0;
		file.status = 'uploading';
		//imageList.unshift(file);
		this.setState({
			'imageList':imageList,
		});
		
		//获取文件签名
		let url = pcUrl('image','preUploadFile');
		let param = {
			'folder_id':this.state.folderInfo.folderId,
			'insert_image':1,
			'order_type':this.state.type,
		};
		param['file_name'] = file.name;
		httpPost(url,param)
			.then(data=>{
				//正式上传
				url = data.host;
				let param = new FormData();
				param.append('name',file.name);
				param.append('key',data['file_name']);
				param.append('policy',data.policy);
				param.append('OSSAccessKeyId',data.accessid);
				param.append('callback',data.callback);
				param.append('signature',data.signature);
				param.append('file',file);
				param.append('success_action_status',200);
				httpPost(url,param,{
					'onUploadProgress':(event)=>{
						let imageList = this.state.imageList;
						file.progress = Math.round(event.loaded*100 / event.total);
						this.setState({
							'imageList':imageList,
						});
					},
					'loadingNode':(<span className="fa fa-spin fa-spinner" style={{'fontSize':'30px'}}></span>),
				})
					.then(data=>{
						let imageList = this.state.imageList;
						file.status = 'process';
						this.setState({
							imageList,
						});
						
						//检查图片队列，是否全部上传完毕
						//let complete = !imageList.find(row=>row.uid && row.status == 'uploading');
						//移出队列
						this.state.uploadFileList.shift();
						let restCount = this.state.uploadFileList.length;
						if(restCount)
							this.handleUpload();
						/*
						else
							this.getList();
						*/
						
						//图片上传完毕，进行处理
						url = pcUrl('image','postUploadFile');
						param = {
							'file_name':data
						};
						httpPost(url,param,{
							'rawResponse':1,
							'hideAjax':true,
						})
							.then(data=>{
								let imageList = this.state.imageList;
								//错误处理
								if(data.code != 0)
								{
									message(data.message);
									
									//清空文件
									file.status = 'error';
									this.setState({
										'imageList':imageList,
									});
								}
								else
								{
									file.status = 'done';
									this.setState({
										imageList,
									});
									//this.getList();
									//检查所有的文件状态
									//let complete = !imageList.find(row=>row.uid && row.status == 'process');
									let complete = !imageList.find(row=>row.uid && row.status != 'done');
									if(complete)
										this.getList();
								}
							});
						
					});
					
			});
	}
	
	//handleUpload({action,data,file,method})
	/*
	handleUpload({action,data,file,method})
	{
		let imageList = this.state.imageList;
		file.progress = 0;
		file.status = 'uploading';
		imageList.unshift(file);
		this.setState({
			'imageList':imageList,
		});
		
		//获取文件签名
		let url = pcUrl('image','preUploadFile');
		let param = data;
		data['file_name'] = file.name;
		httpPost(url,param)
			.then(data=>{
				//正式上传
				url = data.host;
				let param = new FormData();
				param.append('name',file.name);
				param.append('key',data['file_name']);
				param.append('policy',data.policy);
				param.append('OSSAccessKeyId',data.accessid);
				param.append('callback',data.callback);
				param.append('signature',data.signature);
				param.append('file',file);
				param.append('success_action_status',200);
				httpPost(url,param,{
					'onUploadProgress':(event)=>{
						file.progress = Math.round(event.loaded*100 / event.total);
						this.setState({
							'imageList':imageList,
						});
					}
				})
					.then(data=>{
						//图片上传完毕，进行处理
						url = pcUrl('image','postUploadFile');
						param = {
							'file_name':data
						};
						httpPost(url,param,{'rawResponse':1})
							.then(data=>{
								this.state.uploadImageCount--;
								
								//错误处理
								if(data.code != 0)
								{
									message(data.message);
									
									//清空文件
									file.status = 'error';
									this.setState({
										'imageList':imageList,
									});
								}
								else
								{
									data = data.data;
									file.status = 'done';
									file['image_path'] = {
										'thumb_name':data,
										'image_name':data,
									};
									this.setState({
										'imageList':imageList,
									});
								}
								
								//检查图片队列，是否全部上传完毕
								let complete = !imageList.find(row=>row.uid && row.status == 'uploading');
								if(complete)
									this.getList();
							});
					});
			});
	}
	*/
	
	handleUploadChange(data)
	{
		console.log(data);
		return;
		let imageList = this.state.imageList;
		if(data.file)
		{
			let file = data.file;
			let find = this.state.imageList.find(row=>row.uid == file.uid);
			if(!find)
			{
				imageList.unshift(data.file);
			}
			else
			{
				find.status = file.status;
				//处理异常
				if(find.status == 'error')
				{
					message('上传文件失败，'+file.error.message);
				}
				else if(find.status == 'done' && file.response)
				{
					let response = file.response;
					if(response.code != 0)
					{
						message(response.message);
					}
				}
			}
			
			this.setState({
				'imageList':imageList,
			},()=>{
				//全部上传完毕，重新加载页面
				if(imageList.filter(row=>row.uid).length  == imageList.filter(row=>row.uid && row.status == 'done').length || file.status == 'error')
				//if(data.fileList.filter(row=>row.status == 'done').length == data.fileList.length || file.status == 'error')
					this.getList();
			});
		}
	}
	
	batchDeleteImage()
	{
		let selection = this.state.imageList.filter(row=>row.isChecked);
		if(!selection.length)
		{
			message('请选择要删除的图片');
			return false;
		}
		confirm('确认要删除选中的图片吗?')
			.then(()=>{
				this._deleteImage(selection.map(row=>row['image_id']).join(','));
			});
	}
	
	deleteImage(index,event)
	{
		event.stopPropagation();
		let info = this.state.imageList[index];
		
		confirm('确认要删除该图片吗?')
			.then(()=>{
				this._deleteImage(info['image_id']);
			});
	}
	
	_deleteImage(imageIds)
	{
		let url = pcUrl('image','deleteImage');
		let param = {
			'image_ids':imageIds
		};
		httpPost(url,param)
			.then(()=>{
				message('图片删除成功','success');
				this.getList();
			});
	}
	
	downloadImage(index,event)
	{
		event.stopPropagation();
		let info = this.state.imageList[index];
		
		var a = document.createElement('a');
		document.body.appendChild(a);
		
		//a.href = info['image_path']['image_name'];
		a.href = info['raw_path'];
		//a.href = '/api/uploads/20220507/59918ca96fadba3f632c7a259f7b0a2b.jpg';
		a.download = info['image_name'];
		
		a.click();
	}
	
	addCart(index,event)
	{
		event.stopPropagation();
		let info = this.state.imageList[index];
		
		//判断图片是否为cmyk色
		/*
		if(info['color_type'] != 1)
		{
			message('请选择色彩模式为cmyk格式的图片进行下单');
			return;
		}
		*/
		
		let cartList = this.state.cartList;
		let i = cartList.findIndex(row=>row['image_id'] == info['image_id']);
		//加入购物车
		if(i == -1)
		{
			cartList.push(info);
		}
		//在购物车中，则删除
		else
		{
			cartList.splice(i,1);
		}
		
		CommonValue.set('cart_list',cartList);
		this.setState({
			'cartList':cartList,
		});
	}
	
	showOrder(fromCart)
	{
		if(!fromCart) fromCart = 0;
		let folderId = this.state.folderInfo.folderId;
		
		this._showOrder(fromCart);
		//window.location.href=`#/imageList?folderId=${folderId}&mode=addOrder&fromCart=${fromCart}`;
	}
	
	_showOrder(fromCart)
	{
		let selection ;
		if(!fromCart)
		{
			selection = this.state.imageList.filter(row=>row.isChecked);
			if(!selection.length)
			{
				message('请选择要下单的图片');
				return ;
			}
			if(selection.some(row=>row['status'] != 1))
			{
				message('未生成缩略图的记录不能下单');
				return;
			}
		}
		else
		{
			selection = this.state.cartList;
			if(!selection.length)
			{
				message('购物车为空');
				return ;
			}
		}
		
		//判断选中的图片是否为cmyk色
		/*
		if(selection.some(row=>row['color_type'] != 1))
		{
			message('请选择色彩模式为cmyk格式的图片进行下单');
			return ;
		}
		*/
		
		selection = JSON.parse(JSON.stringify(selection));
		selection.forEach((row,index)=>{
			//选择材质
			row['categories'] = [[],[]];
			//图片数量
			row['quantity'] = 1;
			//图片单价
			row['image_price'] = '';
			//图片价格
			row['image_amount'] = '';
			//实付价格
			row['pay_amount'] = '';
			
			//反面图片
			row['back_path'] = [];
			//异形图片
			row['spec_path'] = [];

			//备注
			row['remark'] = '';
		});
		
		let imageList = this.state.imageList;
		imageList.forEach(row=>row.isChecked = false);
		
		CommonValue.set('selected_image_list',selection);
		CommonValue.set('selected_order_type',this.state.type);
		window.location.href = ngUrl('addOrder');
		
		/*
		this.setState({
			'mode':'addOrder',
			'imageList':imageList,
		},()=>{
			this.addOrder.init({
				'imageList':selection
			});
		});
		*/
		/*
		let imageList = this.state.imageList;
		imageList.forEach(row=>row.isChecked = false);
		//初始化订单价格
		let orderInfo = this.state.orderInfo;
		orderInfo['order_amount'] = 0;
		*/
		
		/*
		this.setState({
			'orderCurrent':0,
			'showOrderDialog':true,
			'selectedImageList':selection,
			'orderInfo':orderInfo,
		});
		*/
	}
	
	/*
	back()
	{
		this.setState({'mode':'index'});
		window.location.href=`#/imageList`;
	}
	*/
	
	submitOrder()
	{
		let selectedImageList = this.state.selectedImageList;
		//检查规格是否选择
		let errorIndex = -1;
		selectedImageList.some((row,index)=>{
			if(!row['categories'][0].length)
			{
				errorIndex = index;
				return true;
			}
		});
		if(errorIndex != -1)
		{
			message('请为第'+(errorIndex+1)+'行图片选择材料');
			return false;
		}
		
		let addressId = this.orderAddress.getAddressId();
		
		let url = pcUrl('order','add');
		/*
		let categoriesList = [];
		selectedImageList.forEach((row,index)=>{
			let categories = JSON.parse(JSON.stringify(row['categories']));
			categories[0] = categories[0].join(',');
			categories[1] = categories[1].map(row=>row.name+':'+row.value);
			categories = categories.join('|');
			categoriesList.push(categories);
		});
		*/
		
		let param = {
			'address_id':addressId,
			'image_ids':selectedImageList.map(row=>row['image_id']).join(','),
			'quantity_list':selectedImageList.map(row=>row['quantity']).join(','),
			'categories_list':selectedImageList.map(row=>{ let categories = JSON.parse(JSON.stringify(row['categories'])); categories[1] = categories[1].map(row1=>row1.name+':'+row1.value); return categories; }),
			'back_path_list':selectedImageList.map(row=>(row['back_path'].length ? row['back_path'][0]['url']:'')).join(','),
			'spec_path_list':selectedImageList.map(row=>(row['spec_path'].length ? row['spec_path'][0]['url']:'')).join(','),
		};
		
		httpPost(url,param)
			.then((data)=>{
				//公司管理者，进入下一步
				if(+this.state.userInfo['is_manager'])
				{
					let orderInfo = data;
					let imageList = this.state.imageList;
					imageList.forEach(row=>row.isChecked = false);
					
					this.setState({
						'orderInfo':orderInfo,
						'orderCurrent':1,
						'imageList':imageList,
					},()=>{
						this.payForm.setFieldsValue({
							'method':'alipay'
						});
					});
				}
				else
				{
					message('订单添加成功，您可以进入订单管理页面查看详情','success',1)
						.then(()=>{
							window.location.href = ngUrl('user','order');
						});
				}
			});
	}
	
	changeMethod(method)
	{
		if(this.loop)
			window.clearInterval(this.loop);
		
		if(method == 'wechatpay')
		{
			this.payForm.validateFields(['method'])
				.then((info)=>{
					info.method = method;
					//微信充值，获取服务器返回的二维码
					this._submit(info)
						.then(data=>{
							this.setState({
								'wechatpay_qrcode':pcUrl('index','qrcode',{ 'code':escape(data.url), }),
							});
							let paySn = data['pay_sn'];
							
							//监听订单状态
							this.loop = window.setInterval(()=>{
								let url = pcUrl('user','payInfo');
								let param = {
									'pay_sn':paySn,
									'check_status':1,
								};
								httpPost(url,param)
									.then(data=>{
										//如果已支付状态
										if(10 == data.status)
										{
											this.props.history.push('/user/success?out_trade_no='+paySn);
										}
									});
							},2000);
						});
					
					this.payForm && this.payForm.setFieldsValue({'method':method});
				});
		}
		else
		{
			this.payForm && this.payForm.setFieldsValue({'method':method});
		}
	}
	submit(info)
	{
		this._submit(info)
			.then(data=>{
				//支付宝充值，直接进行跳转
				if(info.method == 'alipay')
				{
					document.write(data);
				}
			});
	}
	
	_submit(info)
	{
		let url = pcUrl('order','charge');
		let param = {
			'order_id':this.state.orderInfo['order_id'],
			'method':info.method == 'alipay' ? 0 : 1,
		};
		
		return new Promise((resolve,reject)=>{
			httpPost(url,param)
				.then(data=>{
					resolve(data);
				})
				.catch(e=>reject(e));
		});
	}
	
	chooseCategory(index)
	{
		this.state.orderImageIndex = index;
		this.setState({
			'showCategoryDialog':true,
		});
	}
	
	submitCategory()
	{
		//计算图片价格
		let result = this.orderCategory.getCategoryResult();
		if(!result.flag)
		{
			message(result.message);
			return false;
		}
		
		let index = this.state.orderImageIndex;
		let selectedImageList = this.state.selectedImageList;
		selectedImageList[index]['categories'] = result.data;
		
		this.calcPrice();
		this.setState({
			'selectedImageList':selectedImageList,
			'showCategoryDialog':false,
		});
	}
	
	quantityChange(type,index)
	{
		let selectedImageList = this.state.selectedImageList;
		let row = selectedImageList[index];
		
		if('-' == type)
		{
			if(row.quantity == 1) return false;
			row.quantity--;
		}
		else if('+' == type)
		{
			row.quantity++;
		}
		this.setState({'selectedImageList':this.state.selectedImageList});
		this.calcPrice();
	}
	
	//计算订单价格
	calcPrice()
	{
		let selectedImageList = this.state.selectedImageList;
		let imageIds = [];
		let categoryIdsList = [];
		let quantityList = [];
		selectedImageList.forEach(row=>{
			if(row['categories'][0].length)
			{
				imageIds.push(row['image_id']);
				categoryIdsList.push(row['categories'][0]);
				quantityList.push(row.quantity);
			}
		});
		if(!imageIds.length) return false;
		
		let url = pcUrl('order','calcPrice');
		let param = {
			'image_ids':imageIds.join(','),
			'category_ids_list':categoryIdsList.map(row=>row.join(',')).join('|'),
			'quantity_list':quantityList.join(','),
		};
		
		httpPost(url,param)
			.then(data=>{
				let orderInfo = this.state.orderInfo;
				orderInfo['order_amount'] = data.total;
				selectedImageList.forEach((row,index)=>{
					let imageId = row['image_id'];
					if(data[imageId])
					{
						row['image_price'] = data[imageId]['image_price'];
						row['image_amount'] = data[imageId]['image_amount'];
						row['pay_amount'] = data[imageId]['pay_amount'];
					}
				});
				this.setState({
					'orderInfo':orderInfo,
					'selectedImageList':selectedImageList,
				});
			});
	}
	
	//删除选中的图片
	deleteSelectedImage(index)
	{
		let selectedImageList = this.state.selectedImageList;
		/*
		if(selectedImageList.length == 1)
		{
			message('不能删除最后的图片');
			return false;
		}
		*/
		
		selectedImageList.splice(index,1);
		this.setState({
			'selectedImageList':[...selectedImageList],
		});
	}
	
	handleRemoveImage(file)
	{
		return new Promise((resolve,reject)=>{
			confirm('确认要删除该文件吗?')
				.then(()=>{
					let url = pcUrl('user','deleteFile');
					let param = {
						'file':[
							file.thumbUrl,
							file.url,
						].join(','),
					};
					httpPost(url,param)
						.then(()=>{
							resolve();
						});
				})
				.catch(()=>{
					reject();
				});
		});
	}
	
	handlePreviewImage(file)
	{
		this.setState({
			'preview':{
				'visible':true,
				'src':file.url,
			},
		});
	}
	
	handleUploadImageChange(data,index,keyName)
	{
		if(data.fileList.length)
		{
			data.fileList.forEach((row,index)=>{
				if(row.response)
				{
					let response = row.response;
					if(response.code != 0)
					{
						message(response.message);
						return;
					}
					
					data.fileList[index] = {
						'uid':index+1,
						'name':row.name,
						'status':'done',
						'thumbUrl':response.data,
						'url':response.data.replace('thumb.',''),
					};
				}
			});
			data.fileList = data.fileList.filter(row=>{
				if(row.response && row.response.code != 0)
					return false;
				else
					return true;
			});
		}
		let list = this.state.selectedImageList;
		list[index][keyName] = data.fileList;
		this.setState({
			//'backPathList':data.fileList,
			'selectedImageList':list,
		});
		
		/*
		this.mainForm.setFieldsValue({
			'business_license':data.fileList,
		});
		*/
	}
	
	render()
	{
		/*
		return (
			<OrderAddress />
		);
		return (
			<OrderCategory />
		);
		*/
		return (
			<>
				{this.state.mode == 'index' && (
					<div className="bg-gray">
						<div className="height-10"></div>
						<div className="image-panel image-list-panel">
							<Affix offsetTop={10}>
								<div className="panel-captain">
									<div className="captain-center" style={{'height':'24px'}}></div>
									{/*
										<span className="captain-center image-meter">
											已用空间
											&nbsp;
											<span className="storage-progress">
												{this.state.usedStorage}/{this.state.totalStorage}
											</span>
										</span>
									*/}
									<span className="captain-left">
										{/*
										<button className="button button-blue">上传</button>
										&nbsp;&nbsp;
										<button className="button button-blue">新建</button>
										&nbsp;&nbsp;
										<button className="button button-red">全选</button>
										*/}
										<Button type="primary" size="small" onClick={()=>this.checkAll()}>全选</Button>
										&nbsp;
										<Button type="primary" size="small" onClick={()=>this.addFolder()}>新建</Button>
										&nbsp;
										{this.state.folderInfo.folderId != 0 ? (
										<>
											<Button type="primary" size="small" onClick={()=>this.clickUpload()}>
												<span className="fa fa-upload"></span>
											</Button>
											&nbsp;
										</>
										):''}
										
										{this.state.imageList.filter(row=>row.isChecked).length ? (
										<Button type="primary" size="small" danger onClick={()=>this.batchDeleteImage()}>删除 ({this.state.imageList.filter(row=>row.isChecked).length})</Button>
										):''}
										&nbsp;&nbsp;
										{/*
										全部：{this.state.folderInfo.directoryName}
										*/}
										<a href="javascript:;" onClick={()=>this.goFolder(0)} className="text-blue"> 全部： </a>
										{this.state.folderInfo.folderList.map((row,index)=>(
											<>
												{index > 1 && (
													
													<span>/ </span>
												)}
												{(index != this.state.folderInfo.folderList.length - 1 && index != 0) ? (
													<a href="javascript:;" onClick={()=>this.goFolder(index)} className="text-blue">
														{row.folderName}
													</a>
												):(
													<span>
														{row.folderName}
													</span>
												)}
												&nbsp;
											</>
										))}
									</span>
									<span className="captain-right">
										<Form layout="inline" ref={e=>this.filterForm=e} onFinish={(data)=>this.getList()}>
											<Form.Item noStyle name="image_name">
												<Input allowClear={true} size="small" style={{'width':'12em'}} placeholder="图片名称" />
											</Form.Item>
											&nbsp;
											{/*
												<Form.Item noStyle name="file_type">
													<Select allowClear={true} style={{'width':'12em'}} placeholder="选择状态">
														{Object.keys(this.state.typeList).map(key=>(
														<Select.Option value={key}>{this.state.typeList[key]}</Select.Option>
														))}
													</Select>
												</Form.Item>
												&nbsp;&nbsp;
												<Form.Item noStyle name="color_type">
													<Select allowClear={true} style={{'width':'12em'}} placeholder="选择状态">
														{Object.keys(this.state.colorTypeList).map(key=>(
														<Select.Option value={key}>{this.state.colorTypeList[key]}</Select.Option>
														))}
													</Select>
												</Form.Item>
												&nbsp;&nbsp;
											*/}
											<Form.Item noStyle>
												<Button type="primary" size="small" htmlType="submit">搜索</Button>
											</Form.Item>
											&nbsp;
											{this.state.imageList.filter(row=>row.isChecked).length ? (
											<>
												<Form.Item noStyle>
													<Button type="primary" size="small" danger onClick={()=>this.showOrder()}>下单 ({this.state.imageList.filter(row=>row.isChecked).length})</Button>
												</Form.Item>
												&nbsp;
											</>
											):''}
											<Form.Item noStyle>
												<Button type="primary" size="small" ghost danger onClick={()=>this.showOrder(1)}> 购物车 ({this.state.cartList.length})</Button>
											</Form.Item>
										</Form>
									</span>
								</div>
							</Affix>
							
							<div className="panel-body">
								{this.state.folderInfo.folderId != 0 && (
									<>
										<div className="text-center">
											<Upload
												accept={this.state.imageTypeList.map(str=>'.'+str).join(',')}
												action={pcUrl('image','uploadFile')}
												data={{'folder_id':this.state.folderInfo.folderId,'insert_image':1}}
												showUploadList={false}
												multiple={true}
												beforeUpload={data=>this.handleBeforeUpload(data)}
												customRequest={data=>this.handleCustomRequest(data)}
												onChange={data=>this.handleUploadChange(data)}>
												<div className="drag-upload">
													<dl>
														<dd className="drag-icon">
															<span className="fa fa-inbox"></span>
														</dd>
														<dt>
															点击左键或者将图片拖拽至该区域
														</dt>
														<dd>
															支持单文件和多文件上传（建议上传CMYK模式图片）
														</dd>
													</dl>
												</div>
											</Upload>
										</div>
										<div className="height-20"></div>
									</>
								)}
								
								<div className="image-list">
									{this.state.folderInfo.folderId ? (
									<>
									{/*
									<div className="image-list-li">
										<dl onClick={e=>this.showFolder(this.state.folderInfo.parentId)}>
										<dl onClick={e=>this.goFolder(this.state.folderInfo.folderList.length - 2)}>
											<dd className="folder">
												<span className="fa fa-level-up"></span>
											</dd>
											<dt className="text-center">
												返回上一级
											</dt>
										</dl>
									</div>
									*/}
									</>
									):''}
									{this.state.imageList.length ? (
										<>
											{this.state.imageList.map((row,index)=>
												!row.uid ?  (
													<div className="image-list-li">
														{!+row['is_directory'] ? 
														(
															row['status'] == 1 ? (
																<dl onClick={e=>this.imageClick(index,e)} title={row['image_name']}>
																	<dd className="image">
																		<img src={row['image_path']['thumb_name']} />
																		<span className="image-checkbox">
																			<Checkbox checked={row.isChecked} />
																		</span>
																		<span className={"image-color "+(row['color_type'] == 1?'spec':'')}>
																			<span> {row['color_type_exp']} </span>
																		</span>
																		<span className="image-tools">
																			<a href="javascript:;" onClick={e=>this.addCart(index,e)} title={this.state.cartList.some(row1=>row1['image_id'] == row['image_id'])?"移除购物车":"加入购物车"}>
																				<span className="fa fa-shopping-cart" style={this.state.cartList.some(row1=>row1['image_id'] == row['image_id'])?{'color':'red'}:{}}></span>
																			</a>
																			<a href="javascript:;" onClick={e=>this.downloadImage(index,e)} title="下载图片">
																				<span className="fa fa-download"></span>
																			</a>
																			<a href="javascript:;" onClick={e=>this.deleteImage(index,e)} title="删除图片">
																				<span className="fa fa-trash"></span>
																			</a>
																		</span>
																		<span className="image-left">
																			{row['file_type']}
																		</span>
																		<span className="image-right">
																		{row['image_dpi']}dpi
																		</span>
																	</dd>
																	<dt>
																		{row['image_name']}
																	</dt>
																	<dd>
																		<span className="float-right">
																			{row['image_dimension']}cm
																		</span>
																		{row['file_size_exp']}
																	</dd>
																	<dd>
																		<span className="float-right">下单{row['order_count']}次</span>
																		<span className="text-blue"> {row['rest_days']}天后自动删除 </span>
																	</dd>
																</dl>
															):(
																<dl onClick={e=>this.imageClick(index,e)} title={row['image_name']}>
																	<dd className="image">
																		<img src={require('@/assets/images/generating_thumb.jpg')} />
																		{/*
																		<span className="image-checkbox">
																			<Checkbox checked={row.isChecked} />
																		</span>
																		*/}
																		<span className="image-tools">
																			<a href="javascript:;" onClick={e=>this.deleteImage(index,e)} title="删除图片">
																				<span className="fa fa-trash"></span>
																			</a>
																		</span>
																	</dd>
																	<dt>
																		{row['image_name']}
																	</dt>
																	<dd>
																		<span className="float-right">
																			未知
																		</span>
																		未知
																	</dd>
																	<dd className="text-blue">
																		{row['rest_days']}天后自动删除
																	</dd>
																</dl>
															)
														):(
															<dl onClick={e=>this.showFolder({'folderId':row['image_id'],'folderName':row['image_name']})} title={row['image_name']}>
																<dd className="folder">
																	{/*
																	<span className="fa fa-folder-o"></span>
																	*/}
																	<img className="folder-icon" src={require('@/assets/images/'+this.state.folderImageList[this.state.type])} />
																	<span className="image-tools">
																		<a href="javascript:;" onClick={e=>this.deleteFolder(row['image_id'],e)}>
																			<span className="fa fa-trash"></span>
																		</a>
																	</span>
																</dd>
																<dt className="text-center">
																	{row['image_name']}
																</dt>
															</dl>
														)}
													</div>
												):(
													<div className="image-list-li">
														<dl className="uploading">
															{row.status == 'prepare'?(
																<dt>
																	<div>
																		等待上传
																	</div>
																</dt>
															):''}
															{row.status == 'uploading'?(
																<dt>
																	<div>
																		{row.progress != 100 ? row.progress+'%' : '处理中'}
																		<br />
																		<span className="fa fa-spinner fa-spin"></span>
																	</div>
																</dt>
															):''}
															{row.status == 'process'?(
																<>
																	{/*
																		<dd className="image">
																			<img src={row['image_path']['thumb_name']} />
																		</dd>
																		<dt style={{'fontWeight':'bold','paddingTop':0,'color':'#333','textAlign':'center'}}>
																			{row['name']}
																		</dt>
																		<dd>
																			&nbsp;
																		</dd>
																		<dd className="text-blue">
																			&nbsp;
																		</dd>
																	*/}
																	<dt>
																		<div>
																			处理中
																		</div>
																	</dt>
																</>
															):''}
															{row.status == 'done'?(
																<>
																	{/*
																		<dd className="image">
																			<img src={row['image_path']['thumb_name']} />
																		</dd>
																		<dt style={{'fontWeight':'bold','paddingTop':0,'color':'#333','textAlign':'center'}}>
																			{row['name']}
																		</dt>
																		<dd>
																			&nbsp;
																		</dd>
																		<dd className="text-blue">
																			&nbsp;
																		</dd>
																	*/}
																	<dt>
																		<div style={{'fontSize':'12px'}}>
																			处理完成，请等候其他队列
																		</div>
																	</dt>
																</>
															):''}
															{row.status == 'error'?(
																<dt>
																	<div>
																		上传失败
																		<br />
																		<span className="fa fa-times-circle text-red"></span>
																	</div>
																</dt>
															):''}
														</dl>
													</div>
												)
											)}
										</>
									):(
										<div className="padding-40 text-center text-gray">暂无图片</div>
									)}
									<div className="clear"></div>
								</div>
							</div>
						</div>
						<Image preview={{...this.state.preview,'onVisibleChange':val=>{let preview = this.state.preview; preview.visible = val; this.setState({'preview':{...preview}});}}} />
						<Modal
							title="请输入文件夹名称"
							width={400}
							visible={this.state.showAddFolderDialog}
							onOk={()=>this.submitAddFolder()}
							onCancel={()=>this.setState({'showAddFolderDialog':false})}
							>
							<Input allowClear={true} placeholder="文件夹名称" value={this.state.addFolderName} onChange={e=>this.setState({'addFolderName':e.target.value})} />
						</Modal>
					</div>
				)}
				
				{/*this.state.mode == 'addOrder' && (
					<AddOrder back={()=>this.back()} changeCart={(imageIds)=>this.setState({'cartList':this.state.cartList.filter(row=>imageIds.includes(row['image_id']))})} ref={e=>this.addOrder = e} />
				)*/}
			</>
		);
	}
}

